/* Do not remove app nodes: preserve its lifecycle. Disable fields outside the allowed slot. */
(() => {
  const approvedPage = /\/pages\/offerte-pagina\/?$/.test(location.pathname);
  const slotSelector = '#SmouzQuoteForm .smouz-offerte-upload';
  function update() {
    document.querySelectorAll('.cl-upload--wrapper').forEach(widget => {
      const allowed = approvedPage && !!widget.closest(slotSelector);
      if (!allowed) {
        widget.hidden = true;
        widget.setAttribute('aria-hidden', 'true');
        widget.querySelectorAll('input,button,select,textarea').forEach(control => {
          if (!control.disabled) control.disabled = true;
          if (control.required) control.required = false;
        });
      }
    });
    const slot = approvedPage && document.querySelector(slotSelector);
    const fallback = document.getElementById('sq-upload-fallback');
    if (slot && fallback) fallback.hidden = !!slot.querySelector('.filepond--root');
  }
  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; update(); });
  }).observe(document.documentElement, {childList:true,subtree:true});
  update();
})();
